import { render, staticRenderFns } from "./TaskPostSelect.vue?vue&type=template&id=8527949a&scoped=true&"
import script from "./TaskPostSelect.vue?vue&type=script&lang=js&"
export * from "./TaskPostSelect.vue?vue&type=script&lang=js&"
import style0 from "./TaskPostSelect.vue?vue&type=style&index=0&id=8527949a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8527949a",
  null
  
)

export default component.exports